import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d141a36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-radio-button" }
const _hoisted_2 = { class: "text-radio relative flex items-center" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "text-[13px] text-gary-text-color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Icon, {
        iconName: _ctx.selected ? 'radio-selected' : 'radio-unselected',
        width: _ctx.width
      }, null, 8, ["iconName", "width"]),
      _createElementVNode("input", {
        type: "radio",
        value: _ctx.inputValue,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.text), 1)
    ])
  ]))
}